import classes from './RelatedContent.module.scss';
import React, { useRef, useEffect}  from 'react';
import globalJson from 'data/content.json';
import { getFileName } from 'helpers/FileCaching';
import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";

import {TweenMax, Power3} from 'gsap';

const relatedContentImages = require.context('assets/images/RelatedContent', true, /.*\.(gif|png|jpe?g|svg)$/i);

const RelatedContent = ({content}) => {

    // const content = globalJson.relatedContent.content;
    let container = useRef();
    let single = useRef([]);

     //Configure scroll magic
     let scrollMagicController = useRef()
     let scrollMagicScene = useRef()

    let content_tl = useRef(new TimelineMax({paused:true}));
    content_tl.current.timeScale(2);

    const configureScrollMagic = () => {

        //Configure scroll magic
        scrollMagicController.current = new ScrollMagic.Controller()
        scrollMagicScene.current = new ScrollMagic.Scene({
                                     triggerHook:0.7
                                 }).addTo(scrollMagicController.current)

        scrollMagicScene.current.triggerElement((container.current));
        // scrollMagicScene.current.duration((single.current.clientHeight));
        scrollMagicScene.current.triggerHook(0.7);
        scrollMagicScene.current.reverse(false);
        scrollMagicScene.current.on("progress", function(event){
            updateTimeline(event.progress);
        })
        scrollMagicScene.current.on("leave", function(event){
        
        })
    }

    const createTimeline = () => {
        TweenMax.set(single.current, {opacity:0, y:50});
        content_tl.current.staggerTo(single.current, 2, {
            opacity: 1, y:0, ease: Power3.easeInOut
        }, 0.5);
      
    }

    const updateTimeline = (progress) => {
        let timelineLength = content_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        content_tl.current.tweenTo(tweenToSeconds);
        
    }

    useEffect(() => {
        createTimeline();
        configureScrollMagic();
      
    }, []);

    const onClick = (title) =>{
        window.gtag('event', "Related Content clicked", {
            'event_category': globalJson.tracking.ga_category,
            'event_label': title+" | Related Content clicked",
            'value':10
            });
        // event.preventDefault();
    }

 
    return(
        <div className={classes.RelatedContent}>
            <div ref={container} className={`container ${classes.RelatedContent__container}`}>
                <div className={`row ${classes.RelatedContent__titleWrapper}`}>
                    <h3  className={classes.RelatedContent__title}>{content.title}</h3>
                </div>
                <div className={`row ${classes.RelatedContent__row}`}>
                    {content.previews.map((value, index) => {
                        return <a ref={el => single.current[index] = el} className={`col-md-4 contentSingle ${classes.RelatedContent__content}`} key={index} onClick={() => onClick(value.title)} href={value.url} target="_blank" rel="noopener noreferrer">
                                    <div className={classes.RelatedContent__contentLink} href="{value.link}" target="blank" >
                                            <div  className={`img_shadow ${classes.RelatedContent__contentImage}`}
                                                style={
                                                    {
                                                        backgroundImage: 'url(' + getFileName(relatedContentImages, value.image) + ')'
                                                    }
                                                }>
                                            </div>
                                        <h3 className={classes.RelatedContent__contentTitle}>{value.title}</h3>
                                    </div>
                                </a>
                    })}
                   
                </div>
            </div>
           


        </div>
    )
};
export default RelatedContent;